import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  constructor(private http: HttpClient) {}
  url = environment.api;

  getAccount(accountId: string) {
    const path = `${this.url}/api/v1/accounts/${accountId}`;
    return this.http.get(path);
  }
}
